import { Accordion, AccordionDetails } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { useFormikContext } from 'formik';
import { StepperForm } from 'shell/view-models/stepper-form';
import FormEditData from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';

interface EditDataProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const EditDataComponent = ({ disabled, isEditMode }: EditDataProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<StepperForm>();

  const onFieldEditDataChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('editDataControl', {
        ...formContext.values.editDataControl,
        [key]: value,
      });
    },
    [formContext.values.editDataControl, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-edit-data-control-content"
        id="panel-person-edit-data-control-header"
        expandIcon={<ExpandMore />}
      >
        <AccordionTitle isEditMode={isEditMode}>Dati di controllo modifica</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <FormEditData
          disabled={disabled}
          isEditMode={false}
          values={formContext.values.editDataControl}
          onChange={onFieldEditDataChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

EditDataComponent.displayName = 'Accordion Other Citizenship component';

const EditData = memo(EditDataComponent);

export default EditData;
